export default __webpack_public_path__ + "static/media/11.ed5094e8.png";